<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="brandingCampaign"
      :model="model"
      entity-name="Campaign"
    />
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import BrandingCampaign from '@/model/dataLayer/api/branding/BrandingCampaign'

export default {
  components: { IkDataTable },
  data: function () {
    return ({
      model: BrandingCampaign
    })
  }
}
</script>
